<template>
  <button
    class="button is-primary max-w-full px-6"
    :class="{ 'is-loading': isLoading }"
    :disabled="!props.variation.sku"
    @click="onClick"
  >
    {{ $texts('cart.addToCart', 'Add to cart') }}
    <SpriteSymbol name="shopping-bag" class="shrink-0" />
  </button>
</template>

<script lang="ts" setup>
import type {
  PageProductVariationGiftFragment,
  PageProductVariationGiveawayFragment,
  PageProductVariationStrapFragment,
  PageProductVariationToolFragment,
  PageProductVariationWatchFragment,
} from '#build/graphql-operations'

const { $texts } = useEasyTexts()

const props = defineProps<{
  variation:
    | PageProductVariationGiftFragment
    | PageProductVariationGiveawayFragment
    | PageProductVariationToolFragment
    | PageProductVariationWatchFragment
    | PageProductVariationStrapFragment
}>()

const isLoading = ref(false)
const { add } = useCart()
const { trackAddToCart } = useAnalyticsTracking()
const { open } = useCartFlyin()

const onClick = async () => {
  isLoading.value = true

  trackAddToCart(props.variation)

  if (props.variation.sku) {
    const result = await add(props.variation.sku)
    if (result?.errors?.length) {
      console.log(result.errors) // eslint-disable-line no-console
    } else {
      open(props.variation)
    }
  }

  isLoading.value = false
}
</script>
